(function () {
  if (window.__czrPromisesInit) return;
  window.__czrPromisesInit = true;

  function openModal(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('czr-lock');
    document.body.style.overflow = 'hidden';
  }

  function closeModal(modalEl) {
    if (!modalEl) return;
    modalEl.classList.remove('is-open');
    modalEl.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('czr-lock');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-czr-open]');
    if (openBtn) {
      e.preventDefault();
      openModal(openBtn.getAttribute('data-czr-open'));
      return;
    }

    var closeBtn = e.target.closest('[data-czr-close]');
    if (closeBtn) {
      closeModal(e.target.closest('.czr3m'));
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var opened = document.querySelector('.czr3m.is-open');
    if (opened) closeModal(opened);
  });
})();
